import validator from "validator";
import { cloneDeep } from "lodash";

// Const
import { organizationType } from "const/nuclias/organization";
import { userType } from "const/nuclias/user";
import {
  defaultSelectedItem,
  defaultSelectedAllSitesItem,
  defaultAccessRoleList,
  defaultAccessLevelTypeList,
  defaultAccountState
} from "../../const";

const getDefaultAccountState = (selectedOrg, user, defaultAccountState) => {
  const accountState = cloneDeep(defaultAccountState);

  accountState.accessPrivilegeRole.list = cloneDeep(defaultAccessRoleList);
  accountState.accessPrivilegeLevelType.list = cloneDeep(defaultAccessLevelTypeList);

  return accountState;
}

const getInviteAccountState = (user, selectedOrg, selectedSiteTag, selectedSite) => {
  const { type: userIdentity } = user;
  const {
    name,
    email,
    accessPrivilegeRole,
    accessPrivilegeLevelType,
    accessPrivilegeLevelOrg,
    managedMSP,
    managedOrganization,
    managedSiteTag,
    managedSite
  } = getDefaultAccountState(selectedOrg, user, defaultAccountState);

  if (selectedOrg.orgType === organizationType.sp) {
    // Role
    accessPrivilegeRole.list[0].isActive = true;
    accessPrivilegeRole.selected = accessPrivilegeRole.list[0];
    accessPrivilegeRole.disabled = true;

    // Access level
    accessPrivilegeLevelType.list[0].isActive = true;
    accessPrivilegeLevelType.selected = accessPrivilegeLevelType.list[0];
    accessPrivilegeLevelType.disabled = true;

    // Own org
    accessPrivilegeLevelOrg.list.push({ id: selectedOrg.id, title: selectedOrg.name, isActive: true });
    accessPrivilegeLevelOrg.selected = accessPrivilegeLevelOrg.list[0];
    accessPrivilegeLevelOrg.disabled = true;

    // Managed MSP
    managedMSP.list.push(cloneDeep(defaultSelectedItem));
    managedMSP.list[0].checked = true;
    selectedOrg.children.forEach(child => {
      managedMSP.list.push({
        id: child.id,
        title: child.name,
        checked: true
      });
    });
  }

  if (selectedOrg.orgType === organizationType.si) {
    // Role
    accessPrivilegeRole.list[0].isActive = true;
    accessPrivilegeRole.selected = accessPrivilegeRole.list[0];

    // Access level
    accessPrivilegeLevelType.list[1].isActive = true;
    accessPrivilegeLevelType.selected = accessPrivilegeLevelType.list[1];
    accessPrivilegeLevelType.disabled = true;

    // Own org
    accessPrivilegeLevelOrg.list.push({ id: selectedOrg.id, title: selectedOrg.name, isActive: true });
    accessPrivilegeLevelOrg.selected = accessPrivilegeLevelOrg.list[0];
    accessPrivilegeLevelOrg.disabled = true;
  }

  if (
    selectedOrg.orgType === organizationType.org &&
    (userIdentity === userType.si || userIdentity === userType.org)
  ) {
    // Role
    accessPrivilegeRole.list[0].isActive = true;
    accessPrivilegeRole.selected = accessPrivilegeRole.list[0];

    // Access level
    accessPrivilegeLevelType.list[2].isActive = true;
    accessPrivilegeLevelType.selected = accessPrivilegeLevelType.list[2];
    accessPrivilegeLevelType.disabled = true;

    // Own org
    accessPrivilegeLevelOrg.list.push({ id: selectedOrg.id, title: selectedOrg.name, isActive: true });
    accessPrivilegeLevelOrg.selected = accessPrivilegeLevelOrg.list[0];
    accessPrivilegeLevelOrg.disabled = true;

    // Managed site tag and managed site
    managedSiteTag.list.push(cloneDeep(defaultSelectedAllSitesItem));
    for (const siteTagId in selectedOrg.storeTagObj) {
      const { name } = selectedOrg.storeTagObj[siteTagId];
      managedSiteTag.list.push({
        id: siteTagId,
        title: name,
        isActive: false
      })
    }
    managedSiteTag.list[0].isActive = true;
    managedSiteTag.selected = managedSiteTag.list[0];

    managedSite.list.push(cloneDeep(defaultSelectedItem));
    for (const siteId in selectedOrg.storeObj) {
      const { name } = selectedOrg.storeObj[siteId];
      managedSite.list.push({
        id: siteId,
        title: name,
        isActive: false
      })
    }
    managedSite.list[0].isActive = true;
    managedSite.selected = managedSite.list[0];
    managedSite.originList = cloneDeep(managedSite.list);
  }

  if (selectedOrg.orgType === organizationType.org && userIdentity === userType.siteTag) {
    // Role
    accessPrivilegeRole.list[0].isActive = true;
    accessPrivilegeRole.selected = accessPrivilegeRole.list[0];

    // Access level
    accessPrivilegeLevelType.list[3].isActive = true;
    accessPrivilegeLevelType.selected = accessPrivilegeLevelType.list[3];
    accessPrivilegeLevelType.disabled = true;

    // Own org
    accessPrivilegeLevelOrg.list.push({ id: selectedOrg.id, title: selectedOrg.name, isActive: true });
    accessPrivilegeLevelOrg.selected = accessPrivilegeLevelOrg.list[0];
    accessPrivilegeLevelOrg.disabled = true;

    // Managed site tag and manged site
    managedSiteTag.list.push(cloneDeep(defaultSelectedAllSitesItem));
    managedSiteTag.list.push({
      id: selectedSiteTag.id,
      title: selectedSiteTag.name,
      isActive: false
    });
    for (const siteTagId in selectedSiteTag.storeTagObj) {
      const { name } = selectedOrg.storeTagObj[siteTagId];
      managedSiteTag.list.push({
        id: siteTagId,
        title: name,
        isActive: false
      });
    }
    managedSiteTag.list[0].isActive = true;
    managedSiteTag.selected = managedSiteTag.list[0];

    managedSite.list.push(cloneDeep(defaultSelectedItem));
    for (const siteId in selectedSiteTag.storeObj) {
      const { name } = selectedOrg.storeObj[siteId];
      managedSite.list.push({
        id: siteId,
        title: name,
        isActive: false
      });
    }
    managedSite.list[0].isActive = true;
    managedSite.selected = managedSite.list[0];
    managedSite.originList = cloneDeep(managedSite.list);
  }

  if (selectedOrg.orgType === organizationType.org && userIdentity === userType.site) {
    // Role
    accessPrivilegeRole.list[0].isActive = true;
    accessPrivilegeRole.selected = accessPrivilegeRole.list[0];

    // Access level
    accessPrivilegeLevelType.list[4].isActive = true;
    accessPrivilegeLevelType.selected = accessPrivilegeLevelType.list[4];
    accessPrivilegeLevelType.disabled = true;

    // Own org
    accessPrivilegeLevelOrg.list.push({ id: selectedOrg.id, title: selectedOrg.name, isActive: true });
    accessPrivilegeLevelOrg.selected = accessPrivilegeLevelOrg.list[0];
    accessPrivilegeLevelOrg.disabled = true;

    // Managed site tag and managed site
    managedSiteTag.list.push(cloneDeep(defaultSelectedAllSitesItem));
    managedSiteTag.list[0].isActive = true;
    managedSiteTag.selected = managedSiteTag.list[0];
    managedSiteTag.disabled = true;

    managedSite.list.push({
      id: selectedSite.id,
      title: selectedSite.name,
      isActive: false
    })
    managedSite.list[0].isActive = true;
    managedSite.selected = managedSite.list.filter(site => site.isActive)[0];
    managedSite.disabled = true;
  }

  return {
    name,
    email,
    accessPrivilegeRole,
    accessPrivilegeLevelType,
    accessPrivilegeLevelOrg,
    managedMSP,
    managedOrganization,
    managedSiteTag,
    managedSite
  };
}

const getEditAccountState = (user, orgTreeMap, selectedOrg, selectedSiteTag, selectedSite, selectedAccount) => {
  const { rawData } = selectedAccount;
  const { type: userIdentity } = user;
  const {
    name,
    email,
    accessPrivilegeRole,
    accessPrivilegeLevelType,
    accessPrivilegeLevelOrg,
    managedMSP,
    managedOrganization,
    managedSiteTag,
    managedSite
  } = getDefaultAccountState(selectedOrg, user, defaultAccountState);
  const id = { value: rawData.id, valid: true };
  name.value = rawData.name;
  name.valid = true;
  email.value = rawData.email;
  email.valid = true;

  accessPrivilegeRole.disabled = false;
  for (const role of accessPrivilegeRole.list) {
    if (role.value === rawData.privilege) {
      role.isActive = true;
      accessPrivilegeRole.selected = role;
    }
  }

  accessPrivilegeLevelType.disabled = true;
  for (const type of accessPrivilegeLevelType.list) {
    if (type.value === rawData.type) {
      type.isActive = true;
      accessPrivilegeLevelType.selected = type;
    }
  }

  accessPrivilegeLevelOrg.list.push({ id: selectedOrg.id, title: selectedOrg.name, isActive: true });
  accessPrivilegeLevelOrg.selected = accessPrivilegeLevelOrg.list[0];
  accessPrivilegeLevelOrg.disabled = true;

  if (selectedOrg.orgType === organizationType.sp) {
    accessPrivilegeRole.disabled = true;

    managedMSP.list.push(cloneDeep(defaultSelectedItem));
    if (rawData.manageResources[0].type === organizationType.sp) {
      managedMSP.list[0].checked = true;
      selectedOrg.children.forEach(child => {
        managedMSP.list.push({
          id: child.id,
          title: child.name,
          checked: rawData.manageResources
        });
      });
    } else {
      managedMSP.list[0].checked = false;
      selectedOrg.children.forEach(child => {
        const checked = rawData.manageResources.find(org => org.id === child.id);
        managedMSP.list.push({
          id: child.id,
          title: child.name,
          checked
        });
      });
    }
  }

  if (
    selectedOrg.orgType === organizationType.org &&
    (userIdentity === userType.si || userIdentity === userType.org)
  ) {
    managedSiteTag.list.push(cloneDeep(defaultSelectedAllSitesItem));
    for (const siteTagId in selectedOrg.storeTagObj) {
      const { name } = selectedOrg.storeTagObj[siteTagId];
      managedSiteTag.list.push({
        id: +siteTagId,
        title: name,
        isActive: false
      })
    }

    managedSite.list.push(cloneDeep(defaultSelectedItem));
    for (const siteId in selectedOrg.storeObj) {
      const { name } = selectedOrg.storeObj[siteId];
      managedSite.list.push({
        id: +siteId,
        title: name,
        isActive: false
      })
    }

    managedSite.originList = cloneDeep(managedSite.list);
    if (rawData.manageResources[0].type === organizationType.org) {
      managedSiteTag.list[0].isActive = true;
      managedSiteTag.selected = managedSiteTag.list[0];

      managedSite.list[0].isActive = true;
      managedSite.selected = managedSite.list[0];
    } else if (rawData.manageResources[0].type === organizationType.tag) {
      const siteTagIndex = managedSiteTag.list.findIndex(siteTag => siteTag.id === rawData.manageResources[0].id);
      managedSiteTag.list[siteTagIndex].isActive = true;
      managedSiteTag.selected = managedSiteTag.list[siteTagIndex];

      managedSite.list[0].isActive = true;
      managedSite.selected = managedSite.list[0];
      for (const siteId in orgTreeMap.withStore) {
        if (orgTreeMap.withStore[siteId].indexOf(rawData.manageResources[0].id) > -1) {
          const { name } = selectedOrg.storeObj[siteId];

          managedSite.list.push({
            id: siteId,
            title: name,
            isActive: false
          })
        }
      }
    } else {
      managedSiteTag.list[0].isActive = true;
      managedSiteTag.selected = managedSiteTag.list[0];

      for (const index in managedSite.list) {
        if (managedSite.list[index].id === rawData.manageResources[0].id) {
          managedSite.list[index].isActive = true;
          managedSite.selected = managedSite.list[index];
        }
      }
    }
  }

  if (selectedOrg.orgType === organizationType.org && userIdentity === userType.siteTag) {
    for (const role of accessPrivilegeRole.list) {
      if (role.value === rawData.privilege) {
        role.isActive = true;
        accessPrivilegeRole.selected = role;
      }
    }

    accessPrivilegeLevelType.disabled = true;
    for (const type of accessPrivilegeLevelType.list) {
      if (type.value === rawData.type) {
        type.isActive = true;
        accessPrivilegeLevelType.selected = type;
      }
    }

    accessPrivilegeLevelOrg.list.push({ id: selectedOrg.id, title: selectedOrg.name, isActive: true });
    accessPrivilegeLevelOrg.selected = accessPrivilegeLevelOrg.list[0];
    accessPrivilegeLevelOrg.disabled = true;

    managedSiteTag.list.push(cloneDeep(defaultSelectedAllSitesItem));
    managedSiteTag.list.push({
      id: selectedSiteTag.id,
      title: selectedSiteTag.name,
      isActive: false
    });
    for (const siteTagId in selectedSiteTag.storeTagObj) {
      const { name } = selectedOrg.storeTagObj[siteTagId];
      managedSiteTag.list.push({
        id: +siteTagId,
        title: name,
        isActive: false
      });
    }

    managedSite.list.push(cloneDeep(defaultSelectedItem));
    for (const siteId in selectedSiteTag.storeObj) {
      const { name } = selectedOrg.storeObj[siteId];
      managedSite.list.push({
        id: +siteId,
        title: name,
        isActive: false
      });
    }

    if (rawData.manageResources[0].type === organizationType.tag) {
      const siteTagIndex = managedSiteTag.list.findIndex(siteTag => siteTag.id === rawData.manageResources[0].id);

      managedSiteTag.list[siteTagIndex].isActive = true;
      managedSiteTag.selected = managedSiteTag.list[siteTagIndex];

      managedSite.list[0].isActive = true;
      managedSite.selected = managedSite.list[0];
    } else {
      managedSiteTag.list[0].isActive = true;
      managedSiteTag.selected = managedSiteTag.list[0];

      const siteIndex = managedSite.list.findIndex(site => site.id === rawData.manageResources[0].id);
      managedSite.list[siteIndex].isActive = true;
      managedSite.selected = managedSite.list[siteIndex];
    }
  }

  if (selectedOrg.orgType === organizationType.org && userIdentity === userType.site) {
    managedSiteTag.list.push(cloneDeep(defaultSelectedAllSitesItem));
    managedSiteTag.list[0].isActive = true;
    managedSiteTag.selected = managedSiteTag.list[0];
    managedSiteTag.disabled = true;

    managedSite.list.push({
      id: selectedSite.id,
      title: selectedSite.name,
      isActive: false
    })
    managedSite.list[0].isActive = true;
    managedSite.selected = managedSite.list.filter(site => site.isActive)[0];
    managedSite.disabled = true;
  }

  return {
    id,
    name,
    email,
    accessPrivilegeRole,
    accessPrivilegeLevelType,
    accessPrivilegeLevelOrg,
    managedMSP,
    managedOrganization,
    managedSiteTag,
    managedSite
  };
}

const changeName = (name, value) => {
  name.value = value;
  name.dirty = true;
  name.valid = validator.isByteLength(value, { min: 1, max: 64 });
}

const changeEmail = (email, value) => {
  email.value = value;
  email.dirty = true;
  email.valid = validator.isEmail(value);
}

const changeAccessPrivilegeRole = (accessPrivilegeRole, item) => {
  for (const role of accessPrivilegeRole.list) {
    role.isActive = false;
    if (role.id === item.id) {
      role.isActive = true;
      accessPrivilegeRole.selected = role;
    }
  }
}

const changeManagedMSP = (managedMSP, item) => {
  if (item.id === 0) {
    const newState = !item.checked;
    for (const org of managedMSP.list) {
      org.checked = newState;
    }

    managedMSP.valid = !item.checked;
  } else {
    for (const org of managedMSP.list) {
      (org.id === item.id) && (org.checked = !org.checked);
    }

    managedMSP.list[0].checked = true;
    managedMSP.valid = false;
    for (const org of managedMSP.list) {
      (!org.checked) && (managedMSP.list[0].checked = false);
      org.checked && (managedMSP.valid = true);
    }
  }
}

const changeManagedSiteTag = (managedSiteTag, item) => {
}

const renewManagedSite = (orgTreeMap, selectedOrg, managedSite, selectedSiteTag) => {
  managedSite.list.length = 0;

  if (selectedSiteTag.id === 0) {
    managedSite.list = cloneDeep(managedSite.originList);
    managedSite.list[0].isActive = true;
    managedSite.selected = managedSite.list[0];
  } else {
    managedSite.list.push(cloneDeep(defaultSelectedItem));
    managedSite.list[0].isActive = true;
    managedSite.selected = managedSite.list[0];

    for (const siteId in orgTreeMap.withStore) {
      if (orgTreeMap.withStore[siteId].indexOf(+selectedSiteTag.id) > -1) {
        managedSite.list.push({
          id: selectedOrg.storeObj[siteId].id,
          title: selectedOrg.storeObj[siteId].name,
          isActive: false,
        })
      }
    }
  }

  return managedSite;
}

const changeManagedSite = (managedSite, item) => {
  for (const siteTag of managedSite.list) {
    siteTag.isActive = false;
    if (siteTag.id === item.id) {
      siteTag.isActive = true;
      managedSite.selected = siteTag;
    }
  }
}

export default {
  getInviteAccountState,
  getEditAccountState,
  changeName,
  changeEmail,
  changeAccessPrivilegeRole,
  changeManagedMSP,
  changeManagedSiteTag,
  renewManagedSite,
  changeManagedSite
};